'use client';

import { c as _c } from "react/compiler-runtime";
import { getCommissionPercentOptions } from '@svenskaspelab/poolbetting/core/lib';
import type { Commission } from '@svenskaspelab/poolbetting/schema/input';
import { useRouter, useSearchParams } from 'next/navigation';
import { type ReactNode } from 'react';
import { type InjectedWalletProps, withContextWallet } from '@/components/index.browser';
import { PixWalletCommissionSelector } from './PixWalletCommissionSelector';
import PixWalletItem from './PixWalletItem';
type PixWalletCommissionSelectorContainerClientProps = {
  name: string;
  selectedPercent: number;
  commissionPercentOptions: number[];
  commissionPercent: Commission;
};
type PixWalletCommissionSelectorContainerClientPropsWithInjectedWallet = PixWalletCommissionSelectorContainerClientProps & InjectedWalletProps;

/**
 * Client component responsible for handling the state of the commission percent selector and updating the query parameters accordingly.
 *
 * @param root0 props for the component
 * @param root0.name name of the product for which the commission is being selected, used in the description of the selector
 * @param root0.selectedPercent the currently selected commission percent, used to set the default value of the selector
 * @param root0.commissionPercentOptions list of commission percent options, used to render the options in the selector
 * @param root0.commissionPercent the commission percent for the activated draw, used to determine if some options should be disabled
 * @param root0.contextWallets wallets from context, used to determine what's visible to the user
 * @returns renders the commission percent selector wrapped in a CouponAdditionsItem
 */
export function PixWalletCommissionSelectorContainerClient(t0) {
  const $ = _c(14);
  const {
    name,
    selectedPercent,
    commissionPercentOptions,
    commissionPercent,
    contextWallets
  } = t0;
  const router = useRouter();
  const searchParams = useSearchParams();
  let commissionPercentOptionsToUse = commissionPercentOptions;
  if (contextWallets === undefined) {
    return;
  }
  const [firstWallet] = contextWallets;
  if (firstWallet) {
    let t1;
    if ($[0] !== firstWallet.sharePrice || $[1] !== firstWallet.soldShares) {
      t1 = getCommissionPercentOptions({
        maxCommission: 10,
        sharePrice: firstWallet.sharePrice,
        soldShares: firstWallet.soldShares
      });
      $[0] = firstWallet.sharePrice;
      $[1] = firstWallet.soldShares;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    commissionPercentOptionsToUse = t1;
  }
  let t1;
  if ($[3] !== router || $[4] !== searchParams) {
    t1 = value => {
      const qs = new URLSearchParams(searchParams.toString());
      qs.set("commission", `${value}`);
      router.replace(`?${qs.toString()}`, {
        scroll: false
      });
    };
    $[3] = router;
    $[4] = searchParams;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const handleOnChange = t1;
  const t2 = `Välj avgift för ${name}`;
  let t3;
  if ($[6] !== commissionPercent || $[7] !== commissionPercentOptionsToUse || $[8] !== handleOnChange || $[9] !== selectedPercent) {
    t3 = <PixWalletCommissionSelector commissionValueOptions={commissionPercentOptionsToUse} onValueChange={handleOnChange} selectedCommissionPercent={selectedPercent} commissionPercent={commissionPercent} />;
    $[6] = commissionPercent;
    $[7] = commissionPercentOptionsToUse;
    $[8] = handleOnChange;
    $[9] = selectedPercent;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== t2 || $[12] !== t3) {
    t4 = <PixWalletItem title={"V\xE4lj avgift"} description={t2}>{t3}</PixWalletItem>;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
}
export default withContextWallet<PixWalletCommissionSelectorContainerClientProps>(PixWalletCommissionSelectorContainerClient);